let replaceFields = {
    bingoList: 'listBingoSpring',  //存在本地的 每次都需要修改
    track: 'spring_h5_event',       //打点名称
    fetch: '/api/v1/spring2023/fetch',
    create: '/api/v1/spring2023/create',
    giftCode: 'Spring2023', //不同礼包码
    exchange: 'https://h5-archero.habby.com',
    exchangeTest: 'https://test-h5-archero.habby.com',

    url: 'https://h5-archero.habby.com/spring/index.html',   //活动部署地址 分享时
    urlTest: 'https://test-h5-archero.habby.com/spring/index.html'
}

export default replaceFields



// WEBPACK FOOTER //
// ./src/data/replace.js